import Messaging from './InfluencerMessaging.js';

export default Messaging;